/**
 * Phase 46 (Plan 46-07) — Status pill for notification dispatch audit rows.
 *
 * Three-state semantic palette per UI-SPEC §Surface 3 Color:
 *   - sent    → emerald  (background `#D1FAE5` / text `#065F46`)
 *   - failed  → rose-600 (background `#FFE4E6` / text `#9F1239`)
 *   - skipped → amber    (background `#FEF3C7` / text `#92400E`)
 *
 * Consumes the v7 Pill primitive (`bg`/`fg`/`dot` props) so the semantic
 * colors flow as inline `style` per PATTERNS.md (data-as-style anti-pattern).
 */
import { Pill } from '../ui/Pill';
import { STATUS_LABELS, type DispatchStatus } from '../../constants/notificationEnums';

export interface StatusPillProps {
  status: DispatchStatus;
}

interface Palette {
  bg: string;
  fg: string;
  dot: string;
  testId: string;
}

const PALETTES: Record<DispatchStatus, Palette> = {
  sent: { bg: '#D1FAE5', fg: '#065F46', dot: '#10B981', testId: 'status-pill-sent' },
  failed: { bg: '#FFE4E6', fg: '#9F1239', dot: '#E11D48', testId: 'status-pill-failed' },
  skipped: { bg: '#FEF3C7', fg: '#92400E', dot: '#F59E0B', testId: 'status-pill-skipped' },
};

export function StatusPill({ status }: StatusPillProps) {
  const palette = PALETTES[status];
  return (
    <span data-testid={palette.testId} data-status={status}>
      <Pill bg={palette.bg} fg={palette.fg} dot={palette.dot}>
        {STATUS_LABELS[status]}
      </Pill>
    </span>
  );
}
